/* rb-b-swap.js — one shared "has the section actually been re-rendered?" test.

   WHY THIS EXISTS
   Seven rb-b-* modules each run a MutationObserver on .js-section__collection,
   because DynamicProductSearch replaces the section with innerHTML on every
   filter change and destroys everything they built. The trouble is that the
   observer ALSO fires for lazy-loaded product images and late-rendering
   widgets — measured 9 bursts during one ordinary scroll down /collections/all,
   with no filter change at all — and each burst made every module redo its
   full pass over the sidebar.

   Profiled in Chrome with the Long Animation Frame API while scrolling:
   rb-b-sidebar.js's apply() alone came to 295ms across 6 hits, 287ms of it
   forced style and layout, on a page whose frame budget is 16ms. That is the
   stutter. It was there before today and was hidden behind the even more
   expensive header measurement that used to sit on the scroll path.

   THE TEST
   A real swap destroys the old .collection-sidebar node, so element IDENTITY is
   the honest signal — not a timer, not a content hash, and definitely not "the
   observer fired". rbbSwap.changed() compares the current sidebar and results
   bar against the ones seen last time and returns true only when one of them
   is a different node (or has appeared, or gone). Comparing two object
   references costs nothing and reads no layout.

   USAGE, from inside a module's observer callback:

     if (!window.rbbSwap.changed('sizeclean')) return;

   Each caller passes its own key so modules cannot consume each other's
   "changed" signal — the first one to ask would otherwise clear it for the
   rest, which is exactly the sort of bug that only shows up on the third
   filter click. */

(function () {
  'use strict';

  var seen = {};   // key -> { sidebar: node, bar: node }

  window.rbbSwap = {
    changed: function (key) {
      var sidebar = document.querySelector('.collection-sidebar');
      var bar = document.querySelector('.collection__filters-active');
      var prev = seen[key];
      seen[key] = { sidebar: sidebar, bar: bar };
      if (!prev) return true;                       // first run
      return prev.sidebar !== sidebar || prev.bar !== bar;
    },
    /* Force the next changed() for this key to return true — for a module that
       bailed out early and wants to be asked again. */
    invalidate: function (key) { delete seen[key]; }
  };
})();
